import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import * as React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Link, useNavigate } from 'react-router-dom';
import { images } from '../../../assets';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

// eslint-disable-next-line react/function-component-definition
export default function VerticalTabs({ headerData }) {
  const [value, setValue] = React.useState(0);

  const searchAllLink = `search/artworks/search-all?query=search-all`;

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      className="tabbg"
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
      onMouseLeave={() => handleChange(0)}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className="overflow-css"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab
          iconPosition="start"
          onMouseEnter={() => handleChange(0)}
          // onMouseLeave={() => handleChange(0)}
          {...a11yProps(0)}
          label={
            <Typography variant="h3" className="font12px account-text">
              {headerData?.discoverArtForYou?.title}
              <br />
              <Typography variant="overline" className="font10px">
                {headerData?.discoverArtForYou?.heading}
              </Typography>
            </Typography>
          }
          // eslint-disable-next-line jsx-a11y/alt-text
          icon={
            <img
              src={headerData?.discoverArtForYou?.icon_image || images.searchNew}
              alt="top bar"
              className="buy-art-img"
            />
          }
        />
        <Tab
          iconPosition="start"
          onMouseEnter={() => handleChange(1)}
          // onMouseLeave={() => handleChange(0)}
          {...a11yProps(1)}
          label={
            <Typography className="font12px account-text">
              {headerData?.findThePerfectFit?.title}
              <br />
              <Typography variant="overline" className="font10px">
                {headerData?.findThePerfectFit?.heading}
              </Typography>
            </Typography>
          }
          // eslint-disable-next-line jsx-a11y/alt-text
          icon={
            <img
              src={headerData?.findThePerfectFit?.icon_image || images.scale}
              alt="top bar"
              className="buy-art-img"
            />
          }
        />
        <Tab
          iconPosition="start"
          onMouseEnter={() => handleChange(2)}
          // onMouseLeave={() => handleChange(0)}
          {...a11yProps(2)}
          label={
            <Typography className="font12px account-text">
              {headerData?.artForYourBudget?.title}
              <br />
              <Typography variant="overline" className="font10px">
                {headerData?.artForYourBudget?.heading}
              </Typography>
            </Typography>
          }
          // eslint-disable-next-line jsx-a11y/alt-text
          icon={
            <img
              src={headerData?.artForYourBudget?.icon_image || images.budget}
              alt="top bar"
              className="buy-art-img"
            />
          }
        />
        <Tab
          iconPosition="start"
          onMouseEnter={() => handleChange(3)}
          // onMouseLeave={() => handleChange(0)}
          {...a11yProps(3)}
          label={
            <Typography className="font12px account-text">
              {headerData?.artNearYou?.title}
              <br />
              <Typography variant="overline" className="font10px">
                {headerData?.artNearYou?.heading}
              </Typography>
            </Typography>
          }
          // eslint-disable-next-line jsx-a11y/alt-text
          icon={
            <img src={headerData?.artNearYou?.icon_image || images.locationNew} alt="top bar" className="buy-art-img" />
          }
        />
        <Tab
          iconPosition="start"
          onMouseEnter={() => handleChange(4)}
          // onMouseLeave={() => handleChange(0)}
          {...a11yProps(4)}
          label={
            <Typography className="font12px account-text">
              {headerData?.curatedSelections?.title}
              <br />
              <Typography variant="overline" className="font10px">
                {headerData?.curatedSelections?.heading}
              </Typography>
            </Typography>
          }
          // eslint-disable-next-line jsx-a11y/alt-text
          icon={
            <img
              src={headerData?.curatedSelections?.icon_image || images.curated}
              alt="top bar"
              className="buy-art-img"
            />
          }
        />

        <Tab
          iconPosition="start"
          onMouseEnter={() => handleChange(5)}
          // onMouseLeave={() => handleChange(0)}
          {...a11yProps(5)}
          className="last-arrow-section"
          label={
            <Link
              href={`${process.env.REACT_APP_USER_APP_URL}/blog`}
              to={`${process.env.REACT_APP_USER_APP_URL}/blog`}
              className="subachor"
            >
              <Typography className="font12px account-text">
                {headerData?.beInspired?.title}
                <br />
                <Typography variant="overline" className="font10px">
                  {headerData?.beInspired?.heading}
                </Typography>
              </Typography>
            </Link>
          }
          // eslint-disable-next-line jsx-a11y/alt-text
          icon={
            <img src={headerData?.beInspired?.icon_image || images.inspired} alt="top bar" className="buy-art-img" />
          }
        />
      </Tabs>
      <TabPanel value={value} index={0} className="tab-right-section">
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography variant="h3" className="font14px subject-text-new">
              Subject
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h3" className="font14px subject-text-new">
              Medium
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h3" className="font14px subject-text-new">
              Style
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4} className="grid-padd">
            {headerData?.discoverArtForYou?.subject?.map((e, index) => (
              <Typography key={e?.id} variant="h6" style={{ cursor: 'pointer' }} className="font12px geometry-text">
                <Link
                  href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&subject=${e?.id}`}
                  to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&subject=${e?.id}`}
                  className="subachor"
                >
                  {e?.v_name}
                </Link>
              </Typography>
            ))}
          </Grid>
          <Grid item xs={4} className="grid-padd">
            {headerData?.discoverArtForYou?.medium?.map((e, index) => (
              <Typography key={e?.id} variant="h6" className="font12px geometry-text">
                <Link
                  href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&medium=${e?.id}`}
                  to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&medium=${e?.id}`}
                  className="subachor"
                >
                  {e?.v_name}
                </Link>
              </Typography>
            ))}
          </Grid>
          <Grid item xs={4} className="grid-padd">
            {headerData?.discoverArtForYou?.style?.map((e, index) => (
              <Typography key={e?.id} style={{ cursor: 'pointer' }} variant="h6" className="font12px geometry-text">
                <Link
                  href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&style=${e?.id}`}
                  to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&style=${e?.id}`}
                  className="subachor"
                >
                  {e?.v_name}
                </Link>
              </Typography>
            ))}
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1} className="tab-right-section">
        <div className="scroll-container topimgwidth">
          <div className="main-image-section">
            {headerData?.findThePerfectFit?.size?.map((e, index) => (
              <div key={e?.id} className="budget-section-inner textcenter">
                <Typography variant="h3" className="font14px subject-text-new">
                  <Link
                    href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                      e?.id ? e?.id : e?.slug
                    }`}
                    to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${e?.id ? e?.id : e?.slug}`}
                    className="subachor"
                  >
                    {e?.name}
                  </Link>
                </Typography>
                <Link
                  href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${e?.id ? e?.id : e?.slug}`}
                  to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${e?.id ? e?.id : e?.slug}`}
                  className="subachor"
                >
                  <img src={e?.v_image ? e?.v_image : images?.small} alt="top bar" className="header-size-img " />
                </Link>
                <Typography variant="h6" className="font10px seeall-text-new">
                  <Link
                    href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${
                      e?.id ? e?.id : e?.slug
                    }`}
                    to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&artwork_size=${e?.id ? e?.id : e?.slug}`}
                    className="subachor"
                  >
                    See All
                  </Link>
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </TabPanel>
      <TabPanel value={value} index={2} className="tab-right-section">
        <div className="scroll-container topimgwidth">
          <div className="main-image-section">
            {headerData?.artForYourBudget?.price?.map((e, index) => (
              <div key={e?.id} className="budget-section-inner budgetsectionsec textcenter">
                <Typography variant="h3" className="font14px subject-text-new">
                  <Link
                    href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                    to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                    className="subachor"
                  >
                    {e?.v_title}
                  </Link>
                </Typography>
                <Link
                  href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                  to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                  className="subachor"
                >
                  <img src={e?.v_image ? e?.v_image : images?.star} alt="top bar" className="budget-size-img " />
                </Link>
                <Typography variant="h6" className="font10px seeall-text-new">
                  <Link
                    href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                    to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&price=${e?.id}`}
                    className="subachor"
                  >
                    See All
                  </Link>
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </TabPanel>
      <TabPanel value={value} index={3} className="tab-right-section">
        <Grid container spacing={2}>
          <div className="scroll-container topimgwidth">
            <div className="main-image-section">
              {headerData?.artNearYou?.locations?.map((e, index) => {
                // eslint-disable-next-line no-unsafe-optional-chaining
                const columnNo = Math.ceil(e?.cities?.length / 10).toString() || '1';

                return e?.cities && e?.cities?.length > 0 ? (
                  <div key={e?.id} className="budget-section-inner">
                    <Typography variant="h3" className="font14px subject-text-new">
                      {e?.v_title}
                    </Typography>
                    <div className="budget-section-inner-sec" style={{ columnCount: columnNo }}>
                      {e?.cities?.map((city, i) => (
                        <Typography key={city?.id} variant="h6" className="font12px geometry-text">
                          <Link
                            href={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&location=${city?.id}`}
                            to={`${process.env.REACT_APP_USER_APP_URL}${searchAllLink}&location=${city?.id}`}
                            className="subachor"
                          >
                            {city?.v_title}
                          </Link>
                        </Typography>
                      ))}
                    </div>
                  </div>
                ) : null;
              })}
            </div>
          </div>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={4} className="tab-right-section">
        <Typography variant="h3" className="font14px subject-text-new">
          Curated Selections
        </Typography>
        <Grid item xs={2.5} className="grid-padd">
          {headerData?.curatedSelections?.curated_sections?.map((e, index) => (
            <Typography key={e?.id} variant="h6" style={{ cursor: 'pointer' }} className="font12px geometry-text">
              <Link
                href={`${process.env.REACT_APP_USER_APP_URL}/section/${e?.slug}`}
                to={`${process.env.REACT_APP_USER_APP_URL}/section/${e?.slug}`}
                className="subachor"
              >
                {e?.title}
              </Link>
            </Typography>
          ))}
        </Grid>
      </TabPanel>
    </Box>
  );
}
